import { eRegistrationActionTypeDefine } from "../../action-types/registration/IRegistrationActions";
import { generateActions } from "../generateActions";

export const registrationActions = {
    ...generateActions(eRegistrationActionTypeDefine, "REG"),
};
